module.exports = __webpack_public_path__ + "img/hadiah-500rb.1c84d50d.png";